export const FETCH_USER_LIST = 'FETCH_USER_LIST'
export const UPDATE_USER_LIST = 'UPDATE_USER_LIST'
export const RECEIVE_USER_LIST = 'RECEIVE_USER_LIST'
export const RECEIVE_UPDATED_USER_LIST = 'RECEIVE_UPDATED_USER_LIST'

export const FETCH_USER_LISTS = 'FETCH_USER_LISTS'
export const RECEIVE_USER_LISTS = 'RECEIVE_USER_LISTS'
